'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["slots", "slotProps", "className", "classes", "sx"];
import * as React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { TypingIndicator } from '@mui/x-chat-headless';
import { styled, createUseThemeProps } from "../internals/zero-styled/index.mjs";
import { mergeSlotProps } from "../internals/mergeSlotProps.mjs";
import { useChatTypingIndicatorUtilityClasses } from "./chatTypingIndicatorClasses.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
const useThemeProps = createUseThemeProps('MuiChatTypingIndicator');
const ChatTypingIndicatorStyled = styled('div', {
  name: 'MuiChatTypingIndicator',
  slot: 'Root',
  overridesResolver: (_, styles) => styles.root
})(({
  theme
}) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
  padding: theme.spacing(0.5, 1.5),
  fontSize: theme.typography.caption.fontSize,
  color: (theme.vars || theme).palette.text.secondary,
  fontStyle: 'italic'
}));
const ChatTypingIndicator = /*#__PURE__*/React.forwardRef(function ChatTypingIndicator(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiChatTypingIndicator'
  });
  const {
      slots,
      slotProps,
      className,
      classes: classesProp,
      sx
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  const classes = useChatTypingIndicatorUtilityClasses(classesProp);
  return /*#__PURE__*/_jsx(TypingIndicator, _extends({
    ref: ref
  }, other, {
    slots: _extends({}, slots, {
      root: slots?.root ?? ChatTypingIndicatorStyled
    }),
    slotProps: _extends({}, slotProps, {
      root: mergeSlotProps({
        className: clsx(classes.root, className),
        sx
      }, slotProps?.root)
    })
  }));
});
if (process.env.NODE_ENV !== "production") ChatTypingIndicator.displayName = "ChatTypingIndicator";
process.env.NODE_ENV !== "production" ? ChatTypingIndicator.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  classes: PropTypes.object,
  className: PropTypes.string,
  slotProps: PropTypes.object,
  slots: PropTypes.object,
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
export { ChatTypingIndicator };